// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"EntranceType_imgWrapper__3V2W1","heroImg":"EntranceType_heroImg__1u3Wy"};